import styled from 'styled-components';

import {getDishPriceWithDiscount} from '~/shared/utils/priceDiscountCalculator';
import PieButton from '~/shared/theme/pie/PieButton';
import {bodyBold} from '~/shared/theme/typography';
import {media} from '~/shared/theme/media';

import DishPrice from '../DishPrice';

const Button = styled(PieButton)`
  width: 100%;
  ${media.minLargeMobile`
    max-width: 400px;
    padding: 12px 16px;
  `}
`;

const StyledDishPrice = styled(DishPrice)`
  align-items: center;
  ${bodyBold}
`;

type ActionButtonProps = {
  secondary?: boolean;
  text: string;
  showPrice?: boolean;
  priceText?: number;
  onClick: () => void;
  discountsData?: ReturnType<typeof getDishPriceWithDiscount>;
};

const ActionButton = ({secondary, text, showPrice, priceText, onClick, discountsData, ...props}: ActionButtonProps) => (
  <Button onClick={onClick} {...props} variant={secondary ? 'secondaryLarge' : 'primaryLarge'}>
    {text}
    {showPrice && (
      <StyledDishPrice
        price={priceText!}
        priceDataTestId="inSubmitDishPriceLabel"
        discountsData={discountsData}
        flipOrder
      />
    )}
  </Button>
);

export default ActionButton;
